import { getLocale } from "../runtime";

const sv_addedshort = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tillagd`
};

const addedshort = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_addedshort(inputs)
	return "addedShort";
};

export { addedshort as "addedShort" };